import React, { useRef, useEffect, useState } from "react";
import EessAutocomplete from "../../../components/autocomplete/EessAutocomplete";
import ZonaSelect from "../../../components/select/ZonaSelect";

export default function FiltroEess({
  initialFilters = {},
  onClose = () => {},
  onSubmit = () => {},
}) {
  const filtroRef = useRef(null);

  // =========================
  // ESTADOS
  // =========================
  const [codigoEess, setCodigoEess] = useState(null); // objeto EESS
  const [eess, setEess] = useState(null);             // objeto EESS


  const [direccion, setDireccion] = useState("");
  const [fechaAlta, setFechaAlta] = useState("");
  const [ruc, setRuc] = useState("");
  const [email, setEmail] = useState("");
  const [zona, setZona] = useState("");

  // =========================
  // 🔄 REHIDRATAR FILTROS
  // =========================
  useEffect(() => {
    setCodigoEess(initialFilters.codigoEess ?? null);
    setEess(initialFilters.eess ?? null);


    setDireccion(initialFilters.direccion ?? "");
    setFechaAlta(initialFilters.fechaAlta ?? "");
    setRuc(initialFilters.ruc ?? "");
    setEmail(initialFilters.email ?? "");
    setZona(initialFilters.zona ?? "");
  }, [initialFilters]);

  // =========================
  // Cerrar al hacer clic fuera o ESC
  // =========================
  useEffect(() => {
    const outside = (e) => {
      if (filtroRef.current && !filtroRef.current.contains(e.target)) {
        onClose();
      }
    };
    const esc = (e) => e.key === "Escape" && onClose();

    document.addEventListener("mousedown", outside);
    document.addEventListener("keydown", esc);

    return () => {
      document.removeEventListener("mousedown", outside);
      document.removeEventListener("keydown", esc);
    };
  }, [onClose]);

  // =========================
  // ADAPTADORES (clave)
  // =========================
  const adaptCodigo = (e) =>
    e ? { ...e, label: e.codigo } : null;

  const adaptNombre = (e) =>
    e ? { ...e, label: e.nombre } : null;

  // =========================
  // SUBMIT
  // =========================
  const handleSubmit = (e) => {
    e.preventDefault();

    onSubmit({
      // === BACKEND (match exacto con Eess) ===
      codigoEstacion: codigoEess?.codigo ?? null,
      nombreEstacion: eess?.nombre ?? null,

      descricaoDireccion: direccion || null,
      descricaoRuc: ruc || null,
      descricaoEmail: email || null,
      dataAlta: fechaAlta || null,

      zona: zona ? { id: zona.id } : null,

      // === UI (rehidratación) ===
      codigoEess,
      eess,
      zona,
      direccion,
      fechaAlta,
      ruc,
      email,
    });
  };



  // =========================
  // RENDER
  // =========================
  return (
    <div className="drawer-backdrop">
      <div
        ref={filtroRef}
        onClick={(e) => e.stopPropagation()}
        className="drawer-panel overflow-auto"
      >
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-title">Filtros</h2>
          <button onClick={onClose} className="btn-cancel" title="Cerrar">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="grid grid-cols-1 gap-4">
          {/* Cod. EE.SS. */}
          <Campo label="Cod. EE.SS.">
            <EessAutocomplete
              value={adaptCodigo(codigoEess)}
              onChange={setCodigoEess}
              placeholder="Buscar código EE.SS..."
              flota="TODOS"
            />
          </Campo>

          {/* EE.SS. */}
          <Campo label="EE.SS.">
            <EessAutocomplete
              value={adaptNombre(eess)}
              onChange={setEess}
              placeholder="Buscar EE.SS..."
              flota="TODOS"
            />
          </Campo>

         
          <Campo label="Dirección">
            <input
              className="input"
              value={direccion}
              onChange={(e) => setDireccion(e.target.value)}
            />
          </Campo>

          <Campo label="Fecha Alta">
            <input
              type="date"
              className="input"
              value={fechaAlta}
              onChange={(e) => setFechaAlta(e.target.value)}
            />
          </Campo>

          <Campo label="RUC">
            <input
              className="input"
              value={ruc}
              onChange={(e) => setRuc(e.target.value)}
            />
          </Campo>

          <Campo label="Email">
            <input
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </Campo>

          <Campo label="Zona">
            <ZonaSelect
              value={zona}
              onChange={setZona}
              placeholder="Seleccionar zona..."
            />
          </Campo>

          <div className="text-right pt-4">
            <button type="submit" className="btn btn-success">
              Aplicar filtros
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Campo({ label, children }) {
  return (
    <div>
      <label className="form-label-fil">{label}</label>
      {children}
    </div>
  );
}
